import { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { useCurrentUserRoles } from '../hooks/useCurrentUserRoles';

export function RequireAdmin() {
  const { session, loading: authLoading, signOut } = useAuth();
  const { loading: rolesLoading, isAdmin } = useCurrentUserRoles();
  const location = useLocation();

  const hasVerifiedAccess = Boolean(session && isAdmin);
  const loading = useMemo(
    () => (authLoading || rolesLoading) && !hasVerifiedAccess,
    [authLoading, hasVerifiedAccess, rolesLoading]
  );

  if (loading) {
    return (
      <div className="full-screen-center">
        <span className="spinner" aria-hidden />
        <p>Kontrol ediliyor...</p>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isAdmin) {
    return (
      <div className="full-screen-center">
        <h2>Yetkiniz yok</h2>
        <p>Bu panele yalnızca admin kullanıcılar erişebilir.</p>
        <button className="button danger" type="button" onClick={() => void signOut()}>
          Çıkış yap
        </button>
      </div>
    );
  }

  return <Outlet />;
}
